<template>
  <div class="d-flex-column justify-start align-start gap-18">
    <div
      class="d-flex-row server_picker_singler_mini b-radius-9 space-between"
      :class="[
        checkoutStore.getSelectedServer?.value === 2 && 'right',
        checkoutStore.getSelectedServer?.value === 1 && 'left',
      ]"
    >
      <div
        class="server_btn b-radius-9 d-flex-row"
        :key="server.id"
        v-for="server in getGamePack.servers"
        role="button"
        @click.stop="() => selectServer(server)"
        :class="[
          checkoutStore.getSelectedServer?.value == server.id && 'active',
        ]"
      >
        <label class="t-white regular-l font-family-2 f-w-500">{{
          server?.title
        }}</label>
      </div>
    </div>
  </div>
</template>

<script>
import Switch from "../../../custom/Switch.vue";

export default {
  data() {
    return {};
  },
  computed: {
    // ...mapGetters(["getGamePack", "getSelectedServer"]),
  },
  components: {
    Switch,
  },

  methods: {
    selectServer(server) {
      if (server.id) {
        this.checkoutStore.setServer(server.id);
      }
    },
    switchClick(option) {
      // this.selectOption(option);
    },
  },
  setup() {
    const { getGamePack } = useGameStore();
    const checkoutStore = useCheckoutStore();
    return {
      getGamePack,
      checkoutStore,
    };
  },
};
</script>

<style lang="scss">
.server_picker_singler_mini {
  background-color: var(--bg-medium);
  padding: 6px 6px;
  position: relative;
  .server_btn {
    min-height: 35px;
    cursor: pointer;
    z-index: 2;
    & > * {
      cursor: pointer;
    }
  }
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    width: 45%;
    left: 0%;
    transform: translate(6px, -50%);
    min-height: 35px;
    background-color: var(--blue-opace);
    border: 1px solid var(--blue);
    border-radius: 9px;
    opacity: 0;
    transition: all 0.2s ease-in-out;
  }
  &.left {
    &::after {
      left: 0%;
      opacity: 1;
    }
  }
  &.right {
    &::after {
      opacity: 1;
      left: 50%;
    }
  }
}
</style>
